import Invoice from '../pages/Invoice/Invoice.js';
import Login from '../pages/Login/Login.js';
import NextPageOfLogin from '../pages/NextPageOfLogin/NextPageOfLogin.js';
import NotificationPage from '../pages/Notification/Notification.js';
import Token from '../pages/Token/Token.js';
import Chat from '../pages/Crm/chat.js';
import Document from '../pages/Documents/Document.js';
import React from "react"
import Report from '../pages/report/report.js';
import ProductApprove from '../pages/ProductApprove/ProductApprove.js';
import Transactions from '../pages/Transactions/Transactions.js';
import Transfer from '../pages/Transfer/Transfer.js';
import Commission from '../pages/Commission/Commission.js';
import Coupons from '../pages/Coupons/Coupons.js';
import Categories from '../pages/Categories/Categories.js';
import CreateCategory from '../pages/Categories/CreateCategory.js';
import Attributes from '../pages/Attributes/Attributes.js';
import CreateAttribute from '../pages/Attributes/CreateAttribute.js';
import Designers from '../pages/Designers/Designers.js';
import Sellers from '../pages/Sellers/Sellers.js';
import Contract from '../pages/Contract/Contract.js';
import Campaigns from '../pages/Campaigns/Campaigns.js';
import CreateCampaign from '../pages/Campaigns/CreateCampaign.js';
import Orders from '../pages/Orders/Orders.js';
const authProtectedRoutes =[
    {path: "/invoice" , component: <Invoice />},
    {path: "/nextpageoflogin" , component: <NextPageOfLogin />},
    {path: "/notification" , component: <NotificationPage />},
    {path: "/token" , component: <Token />},
    {path: "/crm" , component: <Chat />},
    {path: "/doc" , component: <Document />},
    {path: "/report" , component: <Report />},
    {path: "/products" , component: <ProductApprove />},
    {path: "/transactions" , component: <Transactions />},
    {path: "/transfer" , component: <Transfer />},
    {path: "/commission" , component: <Commission />},
    {path: "/coupons" , component: <Coupons />},
    {path: "/categories" , component: <Categories />},
    {path: "/categories-create" , component: <CreateCategory />},
    {path: "/attributes" , component: <Attributes />},
    {path: "/attribute-create" , component: <CreateAttribute />},
    {path: "/designers" , component: <Designers />},
    {path: "/sellers" , component: <Sellers />},
    {path: "/contract" , component: <Contract/>},
    {path: "/campaigns" , component: <Campaigns/>},
    {path: "/campaigns-create" , component: <CreateCampaign/>},
    {path: "/orders" , component: <Orders/>},
]
const publicRoutes = [
    { path: '/', component: <Login />}
]
export { authProtectedRoutes, publicRoutes }